import * as Types from '../../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FinanceBulkImportResultFieldsFragment = { __typename?: 'FinanceBulkImportResult', imported_columns: Array<string>, ignored_columns: Array<string>, file_errors: Array<string>, rows: Array<{ __typename?: 'FinanceBulkImportRowResult', row_number: number, id: string, entity_type?: Types.FinanceBulkImportEntityType | null, name?: string | null, status: Types.FinanceBulkImportRowStatus, errors: Array<{ __typename?: 'FinanceBulkImportRowError', column?: string | null, message: string }>, changes: Array<{ __typename?: 'FinanceBulkImportFieldChange', column: string, old_value: string, new_value: string }> }> };

export type FinanceBulkImportTemplateColumnsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FinanceBulkImportTemplateColumnsQuery = { __typename?: 'Query', financeBulkImportTemplateColumns: Array<string> };

export type ValidateFinanceBulkImportMutationVariables = Types.Exact<{
  columns: Array<Types.Scalars['String']> | Types.Scalars['String'];
  rows: Array<Types.FinanceBulkImportRowInput> | Types.FinanceBulkImportRowInput;
}>;


export type ValidateFinanceBulkImportMutation = { __typename?: 'Mutation', validateFinanceBulkImport: { __typename?: 'FinanceBulkImportResult', imported_columns: Array<string>, ignored_columns: Array<string>, file_errors: Array<string>, rows: Array<{ __typename?: 'FinanceBulkImportRowResult', row_number: number, id: string, entity_type?: Types.FinanceBulkImportEntityType | null, name?: string | null, status: Types.FinanceBulkImportRowStatus, errors: Array<{ __typename?: 'FinanceBulkImportRowError', column?: string | null, message: string }>, changes: Array<{ __typename?: 'FinanceBulkImportFieldChange', column: string, old_value: string, new_value: string }> }> } };

export type ApplyFinanceBulkImportMutationVariables = Types.Exact<{
  columns: Array<Types.Scalars['String']> | Types.Scalars['String'];
  rows: Array<Types.FinanceBulkImportRowInput> | Types.FinanceBulkImportRowInput;
}>;


export type ApplyFinanceBulkImportMutation = { __typename?: 'Mutation', applyFinanceBulkImport: { __typename?: 'FinanceBulkImportResult', imported_columns: Array<string>, ignored_columns: Array<string>, file_errors: Array<string>, rows: Array<{ __typename?: 'FinanceBulkImportRowResult', row_number: number, id: string, entity_type?: Types.FinanceBulkImportEntityType | null, name?: string | null, status: Types.FinanceBulkImportRowStatus, errors: Array<{ __typename?: 'FinanceBulkImportRowError', column?: string | null, message: string }>, changes: Array<{ __typename?: 'FinanceBulkImportFieldChange', column: string, old_value: string, new_value: string }> }> } };

export type StartFinanceBulkImportTemplateReportMutationVariables = Types.Exact<{
  year: Types.Scalars['Int'];
  month: Types.Scalars['Int'];
}>;


export type StartFinanceBulkImportTemplateReportMutation = { __typename?: 'Mutation', startReportGeneration?: boolean | null };

export const FinanceBulkImportResultFieldsFragmentDoc = gql`
    fragment FinanceBulkImportResultFields on FinanceBulkImportResult {
  imported_columns
  ignored_columns
  file_errors
  rows {
    row_number
    id
    entity_type
    name
    status
    errors {
      column
      message
    }
    changes {
      column
      old_value
      new_value
    }
  }
}
    `;
export const FinanceBulkImportTemplateColumnsDocument = gql`
    query FinanceBulkImportTemplateColumns {
  financeBulkImportTemplateColumns
}
    `;

/**
 * __useFinanceBulkImportTemplateColumnsQuery__
 *
 * To run a query within a React component, call `useFinanceBulkImportTemplateColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceBulkImportTemplateColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceBulkImportTemplateColumnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceBulkImportTemplateColumnsQuery(baseOptions?: Apollo.QueryHookOptions<FinanceBulkImportTemplateColumnsQuery, FinanceBulkImportTemplateColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinanceBulkImportTemplateColumnsQuery, FinanceBulkImportTemplateColumnsQueryVariables>(FinanceBulkImportTemplateColumnsDocument, options);
      }
export function useFinanceBulkImportTemplateColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceBulkImportTemplateColumnsQuery, FinanceBulkImportTemplateColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinanceBulkImportTemplateColumnsQuery, FinanceBulkImportTemplateColumnsQueryVariables>(FinanceBulkImportTemplateColumnsDocument, options);
        }
export type FinanceBulkImportTemplateColumnsQueryHookResult = ReturnType<typeof useFinanceBulkImportTemplateColumnsQuery>;
export type FinanceBulkImportTemplateColumnsLazyQueryHookResult = ReturnType<typeof useFinanceBulkImportTemplateColumnsLazyQuery>;
export type FinanceBulkImportTemplateColumnsQueryResult = Apollo.QueryResult<FinanceBulkImportTemplateColumnsQuery, FinanceBulkImportTemplateColumnsQueryVariables>;
export const ValidateFinanceBulkImportDocument = gql`
    mutation ValidateFinanceBulkImport($columns: [String!]!, $rows: [FinanceBulkImportRowInput!]!) {
  validateFinanceBulkImport(columns: $columns, rows: $rows) {
    ...FinanceBulkImportResultFields
  }
}
    ${FinanceBulkImportResultFieldsFragmentDoc}`;
export type ValidateFinanceBulkImportMutationFn = Apollo.MutationFunction<ValidateFinanceBulkImportMutation, ValidateFinanceBulkImportMutationVariables>;

/**
 * __useValidateFinanceBulkImportMutation__
 *
 * To run a mutation, you first call `useValidateFinanceBulkImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFinanceBulkImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFinanceBulkImportMutation, { data, loading, error }] = useValidateFinanceBulkImportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useValidateFinanceBulkImportMutation(baseOptions?: Apollo.MutationHookOptions<ValidateFinanceBulkImportMutation, ValidateFinanceBulkImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateFinanceBulkImportMutation, ValidateFinanceBulkImportMutationVariables>(ValidateFinanceBulkImportDocument, options);
      }
export type ValidateFinanceBulkImportMutationHookResult = ReturnType<typeof useValidateFinanceBulkImportMutation>;
export type ValidateFinanceBulkImportMutationResult = Apollo.MutationResult<ValidateFinanceBulkImportMutation>;
export type ValidateFinanceBulkImportMutationOptions = Apollo.BaseMutationOptions<ValidateFinanceBulkImportMutation, ValidateFinanceBulkImportMutationVariables>;
export const ApplyFinanceBulkImportDocument = gql`
    mutation ApplyFinanceBulkImport($columns: [String!]!, $rows: [FinanceBulkImportRowInput!]!) {
  applyFinanceBulkImport(columns: $columns, rows: $rows) {
    ...FinanceBulkImportResultFields
  }
}
    ${FinanceBulkImportResultFieldsFragmentDoc}`;
export type ApplyFinanceBulkImportMutationFn = Apollo.MutationFunction<ApplyFinanceBulkImportMutation, ApplyFinanceBulkImportMutationVariables>;

/**
 * __useApplyFinanceBulkImportMutation__
 *
 * To run a mutation, you first call `useApplyFinanceBulkImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyFinanceBulkImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyFinanceBulkImportMutation, { data, loading, error }] = useApplyFinanceBulkImportMutation({
 *   variables: {
 *      columns: // value for 'columns'
 *      rows: // value for 'rows'
 *   },
 * });
 */
export function useApplyFinanceBulkImportMutation(baseOptions?: Apollo.MutationHookOptions<ApplyFinanceBulkImportMutation, ApplyFinanceBulkImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyFinanceBulkImportMutation, ApplyFinanceBulkImportMutationVariables>(ApplyFinanceBulkImportDocument, options);
      }
export type ApplyFinanceBulkImportMutationHookResult = ReturnType<typeof useApplyFinanceBulkImportMutation>;
export type ApplyFinanceBulkImportMutationResult = Apollo.MutationResult<ApplyFinanceBulkImportMutation>;
export type ApplyFinanceBulkImportMutationOptions = Apollo.BaseMutationOptions<ApplyFinanceBulkImportMutation, ApplyFinanceBulkImportMutationVariables>;
export const StartFinanceBulkImportTemplateReportDocument = gql`
    mutation StartFinanceBulkImportTemplateReport($year: Int!, $month: Int!) {
  startReportGeneration(
    report_type: FINANCE_BULK_IMPORT_TEMPLATE
    year: $year
    month: $month
  )
}
    `;
export type StartFinanceBulkImportTemplateReportMutationFn = Apollo.MutationFunction<StartFinanceBulkImportTemplateReportMutation, StartFinanceBulkImportTemplateReportMutationVariables>;

/**
 * __useStartFinanceBulkImportTemplateReportMutation__
 *
 * To run a mutation, you first call `useStartFinanceBulkImportTemplateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFinanceBulkImportTemplateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFinanceBulkImportTemplateReportMutation, { data, loading, error }] = useStartFinanceBulkImportTemplateReportMutation({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useStartFinanceBulkImportTemplateReportMutation(baseOptions?: Apollo.MutationHookOptions<StartFinanceBulkImportTemplateReportMutation, StartFinanceBulkImportTemplateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFinanceBulkImportTemplateReportMutation, StartFinanceBulkImportTemplateReportMutationVariables>(StartFinanceBulkImportTemplateReportDocument, options);
      }
export type StartFinanceBulkImportTemplateReportMutationHookResult = ReturnType<typeof useStartFinanceBulkImportTemplateReportMutation>;
export type StartFinanceBulkImportTemplateReportMutationResult = Apollo.MutationResult<StartFinanceBulkImportTemplateReportMutation>;
export type StartFinanceBulkImportTemplateReportMutationOptions = Apollo.BaseMutationOptions<StartFinanceBulkImportTemplateReportMutation, StartFinanceBulkImportTemplateReportMutationVariables>;